import { render, staticRenderFns } from "./AssetsPage.vue?vue&type=template&id=1f738958&scoped=true"
import script from "./AssetsPage.vue?vue&type=script&lang=js"
export * from "./AssetsPage.vue?vue&type=script&lang=js"
import style0 from "./AssetsPage.vue?vue&type=style&index=0&id=1f738958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f738958",
  null
  
)

export default component.exports